import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { Line } from "react-chartjs-2";
import ReactModal from "react-modal";

const MiniGrafico = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [list1, setList1] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleOpenModalTest = () => {
    setIsOpen(true);
    cargarDatos(); // 🔹 carga inicial al abrir
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  // 🔹 FUNCIÓN REUTILIZABLE PARA CARGAR DATOS
  const cargarDatos = useCallback(() => {
    setLoading(true);
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerPriorizados/${props.solicitud}`,
    })
      .then((response) => {
        setList1(response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.solicitud]);

  let filtro = list1.filter((e) => e.grupo === "A10");

  return (
    <>
      {/* 🔹 BOTÓN ABRIR MODAL */}
      <button className="btn btn-primary" onClick={handleOpenModalTest}>
        Ver Gráficos
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Gráficos"
      >
        {/* 🔹 BOTONES SUPERIORES */}
        <br></br> <br></br>
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <button className="btn btn-secondary btn-sm" onClick={closeModal}>
            Volver
          </button>

          <button
            className="btn btn-outline-primary btn-sm"
            onClick={cargarDatos}
            disabled={loading}
          >
            {loading ? "Actualizando..." : "Recargar información"}
          </button>
        </div>
        {/* 🔹 CONTENEDOR GRÁFICOS */}
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {filtro.map((item, index) => {
            const lista = item.lista;

            const data = {
              labels: lista.map((e) => e.ano),
              datasets: [
                {
                  label: "Tendencia",
                  data: lista.map((e) => e.resultado),
                  borderColor: "#0d6efd", // 🔹 color fijo (mejor UX)
                  borderWidth: 2,
                  pointRadius: 2,
                  fill: false,
                  tension: 0.3,
                },
              ],
            };

            const chartOptions = {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { display: false },
              },
            };

            return (
              <div
                key={index}
                style={{
                  width: 300,
                  height: 180,
                  margin: "20px",
                }}
              >
                <center>
                  <p style={{ fontSize: "14px", fontWeight: "bold" }}>
                    {lista[0]?.nombreIndicador}
                  </p>
                  <Line data={data} options={chartOptions} />
                </center>
              </div>
            );
          })}
        </div>
      </ReactModal>
    </>
  );
};

export default MiniGrafico;
